<template>
  <div v-loading="loading">
    <div class="systemHeader">
      <el-button v-if="!isModify" :disabled="auths.indexOf(2) < 0" class="seeHistory blueButton pointer"
                 @click="$router.push({path: '/LookHistory'})">查看历史配置
      </el-button>
      <span class="pointer cancelEdit" v-if="isModify" @click="quite">取消编辑</span>

      <div class="systemCalendar">
        <span class="calendarStart">起始时间</span>
        <span class="calendarTime">{{startTime}}</span>
      </div>
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>评估体系</el-breadcrumb-item>
          <el-breadcrumb-item>{{pages[navState-1].name}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="tabPages">
      <div class="systemNav">
        <div v-for="(item,index) in pages" class="systemNavWrap" :key="index">
          <div @click="changeNavState(index+1)" class="pages pointer" :class="{'isActive': navActive(index+1)}">
            <span>
              <img :src="item.checkedIcon" v-if="navActive(index+1)"/>
              <img :src="item.icon" v-else/>
              {{item.name}}
            </span>
          </div>
          <i v-show="isModify && index!=3" class="el-icon-arrow-right" :class="{'changeColor': navChangeColor(index+1)}"></i>
        </div>
      </div>
      <el-button class="edit blueButton pointer" :disabled="auths.indexOf(2) < 0" v-if="navState == 1 && !isModify" @click="edit">编辑</el-button>
    </div>

    <div>
      <TiXi v-if="navState == 1" :isEdit="isModify"/>
      <jiFen v-if="navState == 2" :isEdit="isModify" ref="jifen"/>
      <XingJI v-if="navState == 3" :isEdit="isModify"/>
      <!--<XingJITwo v-if="navState == 8" :isEdit="isModify" :scoreType="2"/>-->
      <XinYong v-if="navState == 4" :isEdit="isModify"/>
    </div>

    <div v-if="isModify" class="systemFooter">
      <span class="btn-pre" v-html="btnPre" @click="btnPreClick"></span>
      <span class="btn-next" v-html="btnNext" @click="btnNextClick"></span>
    </div>

    <el-dialog class="quitDialog dialog" title="提 示" :visible.sync="quitDialog" width="30%" center>
      <div class="dialog-body"><img src="../../common/images/icon-question.png">确认要退出编辑吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="quitDialog = false" type="text" size="small">取 消</el-button>
        <el-button @click="quite" class="dialog-btn" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  //韩金辰7月重写，子组件星级信用待重写
  import {mapMutations} from "vuex";
  import TiXi from "./TiXi.vue";
  import jiFen from "./jiFen.vue";
  import XingJI from "./XingJI.vue";
  import XinYong from "./XinYong.vue";
  // import XingJITwo from "./XingJi2";
  import utils from '../../common/js/util'

  export default {
    name: "SystemConfig",
    components: {
      TiXi,
      jiFen,
      XingJI,
      XinYong,
      // XingJITwo
    },
    data() {
      return {
        pages: [{
          name: '体系配置',
          icon: require("../../common/images/icon-tixipeizhi.png"),
          checkedIcon: require("../../common/images/icon-tixipeizhiActive.png")
        }, {
          name: '积分',
          icon: require("../../common/images/icon-jifen.png"),
          checkedIcon: require("../../common/images/icon-jifenActive.png")
        }, {
          name: '星级',
          icon: require("../../common/images/icon-xingji.png"),
          checkedIcon: require("../../common/images/icon-xingjiActive.png")
        }, {
          name: '信用',
          icon: require("../../common/images/icon-xinyong.png"),
          checkedIcon: require("../../common/images/icon-xinyongActive.png")
        }],
        loading: false,
        navState: 9,//一开始不渲染组件，主页数据获取完毕后再赋正确的1234值来渲染
        isModify: false,
        startTime: "",
        quitDialog: false,
        alertText: "",
        // 页面内权限
        auths: []
      };
    },
    mounted() {
      this.getData();
      this.getAuth()
    },
    computed: {
      btnPre() {
        return this.navState == 1 ? '取消' : '上一步'
      },
      btnNext() {
        return this.navState == 4 ? '确认修改' : '下一步'
      }
    },
    methods: {
      ...mapMutations(["changeStartTime", "changeSystemArr", 'changejiFenArr', 'changeXingJiArr', 'changeXinYongArr']),
      //工具类-将时间戳转换成YYMM格式
      toYYMM(date) {
        return date.getFullYear() + "-" + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
      },
      //工具类-检查区间是否设置正确
      checkArr(arr, name) {
        //先排序，方便比照
        arr.sort(function (n1, n2) {
          return n1.scoreMin - n2.scoreMin
        })
        for (let i = 0; i < arr.length; i++) {
          if (Number(arr[i].scoreMin) >= Number(arr[i].scoreMax)) {
            return `${name}分值区间范围不符！`;
          }
          if (i > 0) {
            if (arr[i].scoreMin <= arr[i - 1].scoreMax) {
              return `${name}区间不能出现交叉情况！`
            }
          }
        }
      },
      //工具类-弹框提示
      openAlert() {
        this.$message({
          message: this.alertText,
          type: "warning"
        });
      },
      //工具类-确保mounted的体系(跟积分在一起)、星级、信用数据全部准备完毕
      // 只有这时候才能开始渲染主页面的1234，否则1234拿不到数据
      dataAllReady(arr) {
        let flag = true
        arr.map(item => {
          if (!item) {
            flag = false
          }
        })
        if (flag) {
          this.loading = false;
          this.navState = this.$route.query.navState || 1
        }
        return flag
      },
      //CSS工具类-nav切换(各种状态)
      navActive(nav) {
        return this.isModify ? this.navState >= nav : this.navState == nav
      },
      //CSS工具类-nav切换(编辑状态)
      navChangeColor(nav) {
        return this.navState > nav && this.isModify
      },
      //获取数据后更新vuex
      getData() {
        this.loading = true
        let isReady = [false, false, false]//积分和体系在一起，所以一共3个
        this.$http({
          method: "get",
          url: "/rest/ScoreSystemSettings/search"
        }).then(res => {
          let data = res.data;
          let date = new Date(data[0].startTime)
          this.startTime = this.toYYMM(date)
          this.changeStartTime(data[0].startTime)
          //存体系的配置
          this.$http({
            method: "get",
            url: "/rest/ScoreSystemSettings/searchScore?scoreType=1"
          }).then(res => {
            let jifenArr = [];
            data.map(item => {
              if (item.scoreType == 1) {
                res.data.map(item1 => {
                  if (item.masterId == item1.masterId) {
                    item.score = item1.score
                  }
                })
                jifenArr.push(item)
              }
            })
            this.changejiFenArr(jifenArr);
            this.changeSystemArr(data);
            isReady[0] = true
            this.dataAllReady(isReady)
          })
          //存星级的配置
          this.$http({
            method: "get",
            url: "/rest/ScoreSystemSettings/searchScore?scoreType=2"
          }).then(res => {
            var arr = []
            res.data.map(item => {
              arr.push({
                masterId: item.masterId,
                score: item.score,
                scoreMax: item.scoreMax,
                scoreMin: item.scoreMin,
                signId: item.signId,
                scoreType: 2
              })
            })
            this.changeXingJiArr(arr)
            isReady[1] = true
            this.dataAllReady(isReady)
          })
          //存信用的配置
          this.$http({
            method: "get",
            url: "/rest/ScoreSystemSettings/searchScore?scoreType=3"
          }).then(res => {
            var arr = []
            res.data.map(item => {
              arr.push({
                masterId: item.masterId,
                score: item.score,
                scoreMax: item.scoreMax,
                scoreMin: item.scoreMin,
                signId: item.signId,
                scoreType: 3
              })
            })
            this.changeXinYongArr(arr)
            isReady[2] = true
            this.dataAllReady(isReady)
          })
        })
      },
      //获取权限
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 20,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          let data = res.data
          data.forEach(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //点击编辑按钮
      edit() {
        this.isModify = true;
        let date = new Date()
        console.log(date.getTime())
        this.changeStartTime(date.getTime());
        this.startTime = this.toYYMM(date)
      },
      //编辑情况下，点击页面顶端或者第一页时候底端的取消编辑
      quite() {
        this.isModify = false;
        this.quitDialog = false;
        window.location.reload()
      },
      //编辑-跳页检查-检查星级（第三页）
      chekckStar(str) {
        let text = ''
        if (this.$store.state.xingJiArr != "") {
          this.$store.state.xingJiArr.map((item, index) => {
            if (!item.score && item.score !== 0) {
              text = "警告 星级页分值没填写！";
            } else if (item.scoreMax === '') {//应该存，但没存就是''，不能用null等来判断
              text = "警告 星级页分值上限没有填写！";
            } else if (item.scoreMin === '') {//应该存，但没存就是''，不能用null等来判断
              text = "警告 星级页分值下限没有填写！";
            } else if (isNaN(item.score)) {
              text = "警告 星级页分值应该填写数字！";
            } else if (isNaN(item.scoreMin) || isNaN(item.scoreMax)) {
              text = "警告 星级页分值设定应该填写数字！";
            }
          });
        }
        if (this.$store.state.xingJiEdit != '') {
          this.$store.state.xingJiEdit.map(item => {
            if (item.scoreMax < 0) {
              text = "警告 星级设定分值不能为负！";
            } else if (item.scoreMin < 0) {
              text = "警告 星级设定分值不能为负！";
            }
          })
        }
        //检查区间
        this.$store.state.sortStar.map(item => {
          text = this.checkArr(item.long, '星级页') || ''
          text = this.checkArr(item.short, '星级页') || ''
        })
        if (text) {
          this.alertText = text
          this.openAlert();
        } else {
          if (str == 'next') {
            this.navState = 4;
          } else if (str == 'pre') {
            this.navState = 2;
          }//else{仅仅检查数据，不跳页}
        }
      },
      //编辑-跳页检查-检查信用（第四页）
      checkCredit() {
        let text = ''
        let arr = this.$store.state.xinYongArr
        if (arr != "") {
          arr.map((item, index) => {
            if (!item.score && item.score !== 0) {
              text = "警告 信用页分值没填写！";
            } else if (item.scoreMax === '') {//应该存，但没存就是''，不能用null等来判断
              text = "警告 信用页分值上限没有填写！";
            } else if (item.scoreMin === '') {//应该存，但没存就是''，不能用null等来判断
              text = "警告 信用页分值下限没有填写！";
            } else if (isNaN(item.score)) {
              text = "警告 信用页分值应该填写数字！";
            } else if (isNaN(item.scoreMin) || isNaN(item.scoreMax)) {
              text = "警告 信用页分值设定应该填写数字！";
            }
          });
        }
        //检查区间
        this.$store.state.sortPro.map(item => {
          text = this.checkArr(item.long, '信用页') || ''
          text = this.checkArr(item.short, '信用页') || ''
        })
        if (text) {
          this.alertText = text
          this.openAlert();
        }
        return !Boolean(text)
      },
      //点击上一步（取消）按钮，均不校验
      btnPreClick() {
        let nav = this.navState
        switch (nav) {
          case 1:
            this.quitDialog = true;
            break;
          case 2:
          case 3:
          case 4:
            this.navState = nav - 1;//非指针不简写
        }
      },
      //点击下一步（提交）按钮
      btnNextClick() {
        //点下一步均校验
        let nav = this.navState
        if (nav == 1) {//第一页不检查
          this.navState = 2;//非指针不简写
        } else if (nav == 2) {//第二页检查积分，成功后跳页
          if (this.$refs.jifen.checkVals()) this.navState = 3;
        } else if (nav == 3) {//第三页检查星级，成功后跳页
          this.chekckStar('next')
        } else if (nav == 4) {//第四页这时候是保存，检查信用，成功后跳页
          // 在跳页的过程中都已经校验过了，所以仅校验当前页就够了
          if (!this.checkCredit()) {
            return
          }
          this.alertText = "";
          let arr = [];
          //评估体系
          let systemArr = this.$store.state.systemArr
          if (systemArr != "") {
            systemArr.map((item, index) => {
              arr.push({
                scoreType: item.scoreType, //全都有
                masterId: item.masterId, //全都有（除了星级）
                signId: -1
              });
            });
          }
          //积分
          let jiFenArr = this.$store.state.jiFenArr
          let jifenArrNotNull = true//标志位，是否为空的意思
          if (jiFenArr == '') {
            jiFenArr = systemArr
            jifenArrNotNull = false
          }
          jiFenArr.map((item, index) => {
            if (jifenArrNotNull || item.scoreType == 1) {
              //有值就不用这个判断，没值说明在systemArr中遍历，需要判断scoreType
              arr.push({
                scoreType: item.scoreType, //全都有
                masterId: item.masterId, //全都有（除了星级）
                score: item.score
              });
            }
          });
          //星级，星级和信用都用这个exceptArr
          let exceptArr = [118, 119, 120, 121, 122, 123, 124, 125, 127, 128, 129, 130, 131]
          if (this.$store.state.xingJiArr != "") {
            this.$store.state.xingJiArr.map((item, index) => {
              let id = item.masterId
              let obj = {
                masterId: id, //全都有（除了星级）
                signId: item.signId == -1 ? "" : item.signId,
                score: item.score,
              }
              if (exceptArr.indexOf(id) > -1) {
                obj.scoreType = 2
              } else {
                obj.scoreType = item.scoreType
                obj.scoreMin = item.scoreMin
                obj.scoreMax = item.scoreMax
              }
              arr.push(obj)
            });
          }
          let xingJiEdit = this.$store.state.xingJiEdit
          if (xingJiEdit != "") {
            xingJiEdit.map((item, index) => {
              arr.push(item);
            });
            outer:
              for (let i = 0; i < xingJiEdit.length; i++) {
                for (let j = i + 1; j < xingJiEdit.length; j++) {
                  if (xingJiEdit[i].starName == xingJiEdit[j].starName) {
                    this.alertText = "警告 星级页名称重复！";
                    this.openAlert();
                    break outer;//跳出多层循环
                  }
                }
              }
          }
          //信用
          if (this.$store.state.xinYongArr != "") {
            this.$store.state.xinYongArr.map((item, index) => {
              let id = item.masterId
              let obj = {
                masterId: id, //全都有（除了星级）
                signId: item.signId == -1 ? "" : item.signId,
                score: item.score,
              }
              if (exceptArr.indexOf(id) > -1) {
                obj.scoreType = 3
              } else {
                obj.scoreType = item.scoreType
                obj.scoreMin = item.scoreMin
                obj.scoreMax = item.scoreMax
              }
              arr.push(obj)
            });
          }
          if (arr.length == 0) {
            //不走quite方法，直接退出编辑
            this.isModify = false
            utils.myNotify(this, 'error', '保存失败,配置为空')
          } else {
            this.loading = true;
            let sT = this.$store.state.startTime
            arr.map(item => {
              item.startTime = sT;
            });
            this.$http({
              method: "POST",
              url: '/rest/ScoreSystemSettings/saveScoreSystemSettings',
              data: arr
            }).then(res => {
              utils.myNotify(this, 'success', '保存成功')
              this.loading = false;
              this.isModify = false
            }).catch(err => {
              utils.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
              this.loading = false;
            })
          }
        }
      },
      //顶部图标，点击跳页
      changeNavState(state) {
        if (state != this.navState) {
          //本页不跳
          if (state < this.navState) {
            //往回随便跳
            this.navState = state
          } else {
            //非编辑时候随便跳
            if (this.isModify) {
              //往后跳走下一页的逻辑
              let x = state - this.navState
              //navState会变化，所以不能把x的语句直接写在循环里
              for (let i = 0; i < x; i++) {
                //从第一页跳第三页时候，若不延迟，会找不到组件里面的方法
                setTimeout(() => {
                  this.btnNextClick()
                }, 10)
              }
            } else {
              this.navState = state
            }
          }
        }
      },
      //更新左上角时间
    }
  };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .el-breadcrumb__item:last-child > .el-breadcrumb__inner {
    color: #8299dc !important;
  }

  .blueButton {
    text-align: center;
    border: none;
    border-radius: 20px;
    color: white;
    background-color: #8299dc;
    line-height: 22px;
  }

  .systemHeader {
    height: 60px;
    background: white;
    position: relative;
    .seeHistory {
      position: absolute;
      top: 14px;
      left: 46%;
      padding: 5px 15px;
    }
    .cancelEdit {
      padding: 5px 10px;
      background-color: #e3e3e3;
      border-radius: 13px;
      color: #666666;
      position: absolute;
      top: 17px;
      left: 48%;
    }
    .systemCalendar {
      margin-left: 20px;
      display: inline-block;
      width: 230px;
      height: 60px;
      line-height: 60px;
      .calendarStart {
        color: #676767;
        margin-right: 30px;
      }
      .calendarTime {
        font-size: 28px;
        vertical-align: middle;
      }
    }
  }

  .tabPages {
    height: 32px;
    position: relative;
    padding: 19px 0;
    .systemNav {
      float: left;
      .systemNavWrap {
        display: inline-block;
        img {
          margin-right: 5px;
        }
        .pages {
          width: 150px;
          line-height: 30px;
          text-align: center;
          border: 1px solid transparent;
          border-radius: 20px;
          margin: 0 15px;
          display: inline-block;
          color: #666;
          font-size: 18px;
        }
        .changeColor {
          color: #2d2c7a;
          font-weight: bold;
        }
        .isActive {
          border: 1px solid #2d2c7a !important;
          color: #2d2c7a !important;
          font-weight: bold;
        }
      }
    }
    .edit {
      float: right;
      padding: 5px 20px;
    }
  }

  .systemFooter {
    width: 164px;
    margin: 0 auto;
    & > span {
      display: inline-block;
      width: 80px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      cursor: pointer;
    }
    & > span:nth-child(2) {
      color: white;
      background-color: #2d2c7a;
      border-radius: 4px;
    }
  }

  .quitDialog .dialog-body {
    margin: 45px 0 50px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/SystemConfig.vue